






























import { DocumentIcon } from '@vue-hero-icons/outline';
import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
    name: 'FileFormatSelector',
    components: { DocumentIcon },
    props: {
        value: {
            type: String,
            required: false,
        },
        formats: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        name: {
            type: String,
            default: 'fileFormat',
        },
        testIdPrefix: {
            type: String,
            default: 'file-format',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
    },
});
